<template>
  <div>
    <!-- Botones -->
    <div style="margin-bottom: 16px; display: flex;">
      <b-button v-b-modal.new-user-modal class="mr-1" style="display: flex; flex-direction: row; align-items: center;">
        <i class='p-0 fa fa-plus' style="margin-right: 8px;"></i>&nbsp;Añadir usuario
      </b-button>
      <b-button class="ml-1" @click="exportar" style="display: flex; flex-direction: row; align-items: center;">
        <i class='p-0 fa fa-download' style="margin-right: 8px;"></i> Exportar a XLS
      </b-button>
    </div>

    <!-- Listado de usuarios -->
    <v-server-table
      v-if="!loading"
      ref="users-table"
      url="lista-usuarios/"
      class="table-hide-nativetoggler"
      :columns="columns"
      :options="options">

      <div slot="last_login" slot-scope="props">
        <span> {{ props.row.last_login | formatDate }}</span>
      </div>

      <div slot="is_active" slot-scope="props">
        <span v-if="props.row.is_active">Si</span>
        <span v-else>No</span>
      </div>

      <div slot="actions" slot-scope="props">
        <ActionsUser :data="props.row" :index="props.index"></ActionsUser>
      </div>

      <template v-if="options.details" slot="child_row" slot-scope="props" uniqueKey="id"></template>
    </v-server-table>

    <!-- Diálogos de "NewUser" y "EditUser -->
    <NewUser :permisos="permisos" @update-users-list="updateUsersList"></NewUser>
    <EditUser :permisos="permisos" :user="selectedUser" :key="selectedUser.id"
              @update-users-list="updateUsersList"></EditUser>
  </div>
</template>

<style>

.table thead th {
  position: sticky;
  top: 0;
}

tr.tr-users-table td {
  padding-bottom: 4px !important;
  padding-top: 4px !important;
  vertical-align: middle;
}

.table-responsive {
  padding-bottom: 0 !important;
  overflow-y: auto;
  max-height: 69vh;
}

</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import ActionsUser from './ActionsUser.vue';
import NewUser from '../new-user/NewUser';
import EditUser from '../edit-user/EditUser';
import EventBus from '../../../../Modules/EventBus';
import * as FileSaver from 'file-saver';
import moment from 'moment';

export default {
  name: 'UsersList',
  props: ['permisos'],
  components: {Loader, Table, ActionsUser, NewUser, EditUser},
  data () {
    return {
      columns: ['username', 'email', 'first_name', 'last_name', 'last_login', 'is_active', 'actions'],
      options: {
        rowClassCallback: () => {
          return 'tr-users-table';
        },
        draggable: false,
        filterByColumn: true,
        filterable: ['username', 'email', 'first_name', 'last_name', 'last_login', 'is_active'],
        sortable: ['username', 'email', 'first_name', 'last_name', 'last_login', 'is_active'],
        // templates: {'actions': ActionsUser},
        dateColumns: ['last_login'],
        dateFormat: 'YYYY/MM/DD',
        perPage: 15,
        perPageValues: [],
        pagination: {
          chunk: 10,
          dropdown: false
        },
        params: {
          'paginated': true
        },
        orderBy: {
          ascending: false
        },
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        skin: 'table-hover',
        sortIcon: {
          base: 'fa',
          up: 'fa-caret-down',
          down: 'fa-caret-up',
          is: 'fa-sort'
        },
        datepickerOptions: {
          showDropdowns: true
        },
        headings: {
          username: 'Nick',
          email: 'Email',
          first_name: 'Nombre',
          last_name: 'Apellidos',
          last_login: 'Últ. Conexión',
          is_active: 'Activo',
          actions: 'Acciones'
        },
        requestFunction: function (data) {
          this.loading = true;
          let params = Object.keys(data.search);

          // for each column in the table
          for (let index = 0; index < params.length; index++) {
            const element = params[index];

            let val = data.search[element];
            if (val) {
              if (element === 'last_login') {
                data[element + '__date__gte'] = val.start;
                data[element + '__date__lte'] = val.end;
              } else if (element === 'is_active') {
                const isActive = val.toLowerCase();
                if (isActive === 'si' || isActive === 'no') {
                  data[element] = isActive === 'si';
                }
              } else {
                data[element + '__icontains'] = val.trim();
              }
            }
          }

          // Eliminamos los atributos "search" y "byColumn" para no pasarlos como parametros
          delete data.search;
          delete data.byColumn;

          // Realizamos la petición
          return this.$http.get(this.url, {params: data}).then(function (data) {
            this.loading = false;
            return data.json();
          }, function (e) {
            this.loading = false;
            this.dispatch('error', e);
            EventBus.$emit('show-error-alert', 'Error al recuperar el listado de usuarios');
          }.bind(this));
        },
        responseAdapter: function (resp) {
          return {
            data: (resp) ? resp.results : [],
            count: (resp) ? resp.count : 0
          };
        }
      },
      modalTitle: 'Gestión Usuarios',
      selectedUser: {},
      loading: false,
      downloading: false
    };
  },
  computed: {},
  mounted () {
    EventBus.$on('edit-user', this.showEditUserModal);
  },
  beforeDestroy () {
    EventBus.$off('edit-user', this.showEditUserModal);
  },
  filters: {
    formatDate: function (date) {
      return (date) ? moment(date).format('YYYY-MM-DD') : '';
    }
  },
  methods: {
    refresh: function () {
      this.$refs['users-table'].refresh();
    },
    getFilterColumns: function () {
      return this.$refs['users-table'].query;
    },
    getOrderByColumn: function () {
      return this.$refs['users-table'].orderBy;
    },
    showEditUserModal: function (selectedUser) {
      // Si el usuario seleccionado es el mismo que la última vez, mostramos el dialogo.
      // En caso contrario, actualizamos el usuario seleccionado que provocará la recreación del dialogo y lo mostrará automáticamente.
      if (selectedUser.id === this.selectedUser.id) {
        this.$bvModal.show('edit-user-modal');
      } else {
        this.selectedUser = selectedUser;
      }
    },
    updateUsersList: function () {
      this.$refs['users-table'].refresh();
    },
    exportar: function () {
      const filterColumns = this.getFilterColumns();
      const orderByColumn = this.getOrderByColumn();

      let params = Object.keys(filterColumns);

      // Aplicamos los sufijos de django según el tipo de campo
      const filters = {};
      for (let index = 0; index < params.length; index++) {
        const element = params[index];

        let val = filterColumns[element];
        if (val) {
          if (element === 'last_login') {
            filters[element + '__date__gte'] = val.start;
            filters[element + '__date__lte'] = val.end;
          } else if (element === 'is_active') {
            const isActive = val.toLowerCase();
            if (isActive === 'si' || isActive === 'no') {
              filters[element] = isActive === 'si';
            }
          } else {
            filters[element + '__icontains'] = val.trim();
          }
        }
      }

      // Query parameters and options
      let orderBy = (orderByColumn.column) ? orderByColumn.column : null;
      orderBy = (orderByColumn.ascending) ? '-' + orderBy : orderBy;
      const queryConfig = {filters: filters, orderBy: orderBy};
      const options = {responseType: 'blob'};

      // Realizamos la petición
      this.downloading = true;
      return this.$http.post('lista-usuarios/exportar/', queryConfig, options).then(function (response) {
        this.downloading = false;
        const excelFile = new File([response.data], 'listado_usuarios.xlsx');
        FileSaver.saveAs(excelFile, excelFile.name);

        // For CSV files
        // const blob = new Blob(['\ufeff', response.data]);
        // const csvFile = new File([blob], 'listado_usuarios.csv');
        // FileSaver.saveAs(csvFile, csvFile.name);
      }, function (reason) {
        this.downloading = false;
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al exportar a csv');
      }.bind(this));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/users-management/users-list/UsersList.vue